












import Vue from 'vue'
import TranslationDisplay from '../../components/base/Translation/TranslationDisplay.vue'
import BaseDescription from '../../components/base/BaseDescription.vue'
import LiftLinkBtn from '../../components/Domain/Lift/LiftLinkBtn.vue'
import LiftTitle from '../../components/Domain/Lift/LiftTitle.vue'
import LiftDescription from '../../components/Domain/Lift/LiftDescription.vue'

export default Vue.extend({
  name: 'LatestDescription',
  components: { LiftDescription, LiftTitle, LiftLinkBtn, BaseDescription, TranslationDisplay },
  props: {
    lift: {
      type: Object,
      required: true
    },
  }
})
